export default __webpack_public_path__ + "static/media/fluentCall.a93369e5.svg";